exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ContacSellertInfo__contactInfo___2-w3b {\n  font-size: 15px;\n  opacity: 0.65;\n  color: #000000;\n  word-break: break-all; }\n", ""]);

// exports
exports.locals = {
	"contactInfo": "ContacSellertInfo__contactInfo___2-w3b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/ContacSellertInfo/ContacSellertInfo.scss
// module id = 4511
// module chunks = 6